import { render, staticRenderFns } from "./BaseChannelTimeSeries.vue?vue&type=template&id=47b79882&"
import script from "./BaseChannelTimeSeries.vue?vue&type=script&lang=js&"
export * from "./BaseChannelTimeSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports